import * as React from "react";
import { Dispatch, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { IState, IResultEntity, IDataEntity, IDataEntityResponse, IFundFilterResponse, IShareClassFilterResponse, IFilterRequest, ISearch, IAppParams, IPageProperties, ITypeahead } from "../models";
import { PagePerformance } from "../components/PagePerformance";
import { toggleLoading } from "../actions/loading";
import { BASE_SEARCH_REQUEST } from "../data";
import { isNullOrUndefined, isNullOrEmpty } from "../utils";
import { getShareClassAndFund, primeCompareCollection, addToCompare, removeFromCompare, getFunds, getFilters, changeFilter, toggleFund, toggleShareClass, toggleAllFunds, toggleShareClassPerformance } from "../actions";

@connect(mapStateToProps, mapDispatchToProps)
export class PagePerformanceContainer extends React.Component<React.Props<{}> & IPageProperties, {}>{
	componentWillMount() {
		this.props.getShareClassAndFund({}, this.props.appParams);
		this.props.getFunds(Object.assign({}, BASE_SEARCH_REQUEST, { limit: 1000 }), this.props.appParams, true);
	}

	render() {
		let { shareClass, benchmarks } = this.props;

		if (isNullOrUndefined(shareClass) || isNullOrUndefined(shareClass.properties) || isNullOrUndefined(shareClass.properties.launch_date) && isNullOrEmpty(benchmarks)) {
			return null;
		}

		return (
			<PagePerformance {...this.props} />
		);
	}
}

function mapStateToProps(state: IState, ownProps: any): IPageProperties {
	return {
		isLoading: state.loading.isLoading,
		fund: state.fund,
		shareClass: state.shareClass,
		filterOptions: state.filterOptions,
		typeahead: state.typeahead as ITypeahead[],
		filter: state.filter,
		watchlist: state.watchlist,
		benchmarks: state.benchmarks,
		compare: state.compare
	};
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IPageProperties {
	return {
		getShareClassAndFund: bindActionCreators(getShareClassAndFund, dispatch),
		getFunds: bindActionCreators(getFunds, dispatch),
		addToCompare: bindActionCreators(addToCompare, dispatch),
		removeFromCompare: bindActionCreators(removeFromCompare, dispatch),
		primeCompareCollection: bindActionCreators(primeCompareCollection, dispatch)
	};
}


// WEBPACK FOOTER //
// ./src/client/containers/PagePerformanceContainer.tsx